import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const StripePersonFormPage = () => import('@modules/stripe/stripe-person/components/stripe-person-form-page.vue');

export default [{
  name: '',
  path: '',
  component: Layout,
  meta: {
    auth: true
  },
  children: [
    {
      name: 'stripePersonCreate',
      path: '/subproperty/settings/finantial/account/:connectedAccountId/person/new',
      component: StripePersonFormPage,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
      props: true,
    },
    {
      name: 'stripePersonEdit',
      path: '/subproperty/settings/finantial/account/:connectedAccountId/person/:id/edit',
      component: StripePersonFormPage,
      meta: {
        auth: true,
        permission: Permissions.values.subpropertyRead,
      },
      props: true,
    },
  ],
}];
